import { TrackingEvent, TraceableProcess } from '../../../services/analytics/model';

export class TermsAndConditionsInAppointment implements TrackingEvent {
  public readonly action = 'Terms & Privacy Policy Accepted';
  public readonly category = TraceableProcess.NAVIGATION;
  public readonly label = `section = Appointment, termsConditions = true, userPhoneNumber = ${this.userPhoneNumber}`;

  constructor(public readonly userPhoneNumber: string) {}
}
